export default __webpack_public_path__ + "static/media/04.5d6407ad.mp3";